<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      class="modal-mask skip-context-menu"
      @click="onBackDropClick"
    >
      <div
        ref="container"
        class="modal-container bg-white dark:bg-slate-800 skip-context-menu"
        :class="size"
        :style="containerStyle"
        @click.stop
      >
        <woot-button
          v-if="showCloseButton"
          color-scheme="secondary"
          icon="dismiss"
          variant="clear"
          class="modal--close"
          @click="close"
        />
        <div class="modal-drag-handle cursor-move" @mousedown="startDrag">
          <slot name="header" />
        </div>
        <div class="modal-content">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DraggableModal',
  props: {
    show: { type: Boolean, default: false },
    onClose: { type: Function, required: true },
    closeOnBackdropClick: { type: Boolean, default: true },
    showCloseButton: { type: Boolean, default: true },
    size: { type: String, default: '' },
    initialLeft: { type: Number, default: null },
    initialTop: { type: Number, default: null },
  },
  data() {
    return {
      dragging: false,
      offsetX: 0,
      offsetY: 0,
      left: 0,
      top: 0,
    };
  },
  computed: {
    containerStyle() {
      return {
        position: 'absolute',
        left: `${this.left}px`,
        top: `${this.top}px`,
      };
    },
  },
  watch: {
    show(val) {
      if (val) this.$nextTick(this.centerIfNeeded);
    },
  },
  mounted() {
    if (this.show) {
      this.$nextTick(this.centerIfNeeded);
    }
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    centerIfNeeded() {
      const el = this.$refs.container;
      if (!el) return;
      const { innerWidth: vw, innerHeight: vh } = window;
      const cw = el.offsetWidth || 600;
      const ch = el.offsetHeight || 400;
      this.left = this.initialLeft != null ? this.initialLeft : Math.max((vw - cw) / 2, 0);
      this.top = this.initialTop != null ? this.initialTop : Math.max((vh - ch) / 2, 0);
    },
    close() {
      this.onClose();
    },
    onBackDropClick() {
      if (this.closeOnBackdropClick) {
        this.onClose();
      }
    },
    startDrag(e) {
      const el = this.$refs.container;
      if (!el) return;
      this.dragging = true;
      this.offsetX = e.clientX - this.left;
      this.offsetY = e.clientY - this.top;
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    onDrag(e) {
      if (!this.dragging) return;
      const el = this.$refs.container;
      if (!el) return;
      const { innerWidth: vw, innerHeight: vh } = window;
      const cw = el.offsetWidth;
      const ch = el.offsetHeight;
      let nextLeft = e.clientX - this.offsetX;
      let nextTop = e.clientY - this.offsetY;
      // Clamp within viewport
      nextLeft = Math.min(Math.max(0, nextLeft), Math.max(0, vw - cw));
      nextTop = Math.min(Math.max(0, nextTop), Math.max(0, vh - ch));
      this.left = nextLeft;
      this.top = nextTop;
    },
    stopDrag() {
      this.dragging = false;
      this.removeListeners();
    },
    removeListeners() {
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  },
};
</script>

<style scoped>
.modal-drag-handle {
  /* Keep header grabbable without affecting content */
}
</style>

